import React from "react";

import PDFReader from "./PDFReader";

import "./styles.css";

const PDFViewer = props => (
  <div className="App w-100">
    <PDFReader
      src={props.src}
      enableSave={props.enableSave}
      enablePrint={props.enablePrint}
      lastPageOpened={props.lastPageOpened}
      documentJSON={props.documentJSON}
      pageAnnotations={props.pageAnnotations}
      readedPages={props.readedPages}
      onChange={props.onChange || (() => null)}
    />
  </div>
);

export default PDFViewer;
